import { Component, OnInit } from '@angular/core';
import { ElectronicConsultation } from '../../Models/electronic-consultation';
import { DomSanitizer } from '@angular/platform-browser';
import { ElectronicConsultationService } from '../../services/electronic-consultation.service';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';

@Component({
  selector: 'get-electronic-consultation-details',
  templateUrl: './get-electronic-consultation-details.component.html',
  styleUrls: ['./get-electronic-consultation-details.component.scss']
})
export class GetElectronicConsultationDetailsComponent implements OnInit {
 model = {} as ElectronicConsultation;
  constructor(private route: Router,
      private diag: NbDialogRef<GetElectronicConsultationDetailsComponent>,
      public sanitizer: DomSanitizer,
      private service: ElectronicConsultationService) { }

 ngOnInit() {
       this.route.events.subscribe(()=>{
       this.diag.close('false');
      });
   }
   getLabelData(text) {
     return this.sanitizer.bypassSecurityTrustHtml(text);
   }
 
   close() {
     this.diag.close();
   }
 
   downloadFile(fileName) {
     this.service.downloadFile(fileName).subscribe((blob) => {
           downloadFileUtil(blob, fileName);
         });
   }
 
}


